import { render, staticRenderFns } from "./LocationPage.vue?vue&type=template&id=7853120e&"
import script from "./LocationPage.vue?vue&type=script&lang=js&"
export * from "./LocationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports